<template>
  <div class="mainpage">
    <!--<div class="top_banner">Banner Top</div>-->
    <div class="columns">
      <div class="column is-one-third is_padding">
        <div class="box" id="box1">
  <article class="media">
    <div class="media-left">
      <figure class="image is-64x64">
        <img src="nmea.jpg" alt="Image">
      </figure>
    </div>
    <div class="media-content">
      <div class="content thefont2">
        <p>
          <strong>NMEA decoder</strong>
          <br>This tool decode NMEA sentences : $--RMC , $--GGA , $--GLL
          <br>The positions are plotted in a map and saved in a CSV file.
          <br><a href="http://www.sramp.com">Brought to you by www.sramp.com</a> 
          <br>
        </p>
      </div>
    </div>
  </article>
</div>
 <div class="box"  id="box2">
    <textarea class="textarea is-info  thefont1" v-model="nmeaCode" placeholder="paste here your NMEA sentences" rows="5" ></textarea>
    <br>
    <a class="button is-small is-info is-pulled-right" @click="doTranslate()">Translate</a>
    <br>
 </div>
  <div class="box is_padding"  id="box3">
    <VueScrollTable :options="options" :columns="columns" :rows="rows" :selectedItem="selectedItem"></VueScrollTable>
      <a class="button  is-small is-info is-pulled-right" @click="doExport()">Export</a>
        <template v-if="sel_id>=0">
       <a class="button  is-small is-info is-pulled-left" @click="doShowAll()">Show All</a>
       </template>
  </div>
      </div>
      <div class="column">
      <GmapMap ref="mmm" id="gmap" :center=center :zoom="7">
           <gmap-marker v-for="m in rows" :key="m.id" :position="{lat:parseFloat(m.lat), lng:parseFloat(m.lon)}" :z-index="1000" :clickable="false"  :draggable="false" :icon="getIcon(m,m.id==sel_id)">
           </gmap-marker>
      </GmapMap>
      </div>
    </div>
    <div class="bottom_banner_wrapper">
    <div class="bottom_banner">
      <adsense/>
    </div>
    
    </div>
  </div>
</template>
<script>
import VueScrollTable from './VueScrollTable.vue'
import adsense from './VueAdsense.vue'
 import {UtilityMixin} from '../mixins/UtilityMixin.js';
 export default {
  name: 'MainPage',
  mixins: [UtilityMixin],
    data: function() {
            return {
              api_server:"",
              download:null,
      nmeaCode:"",
     clickRow:null,
      center:{lat:51, lng:0},
         sel_id:-1,
         selectedItem:null,
         rows: [],
         columns: [],
        options: {
          id:"LS001",
          isResizeable: true,
          isSelectable: true,
          cssContainer: "",
          cssHeader: "table_list_header",
          cssBody: "table_list",
          cssRows: "table_list",
          order_col: "id"
        } 
    }
    },
     components: {
      VueScrollTable,
      adsense
    },
 mounted(){
       this.$nextTick(function() {
          this.initColumns()
          window.addEventListener('resize', this.getWindowHeight)
          this.getWindowHeight()
        })
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.getWindowHeight)
  },
   methods:{
     initColumns() {
        var vm = this
        var columns = [

                        {id:"id",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "ID",alignment_th: 'left_align',alignment_td: 'right_align',width: 40,elastic: false,filter: "",order: 0,image: false},
                        {id:"date",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "Date",alignment_th: 'left_align',alignment_td: 'center_align',width: 60,elastic: true,filter: "",order: -1,image: false},
                        {id:"time",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "Time",alignment_th: 'left_align',alignment_td: 'center_align',width: 60,elastic: true,filter: "",order: -1,image: false},
                        {id:"lat",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "Lat",alignment_th: 'left_align',alignment_td: 'center_align',width: 60,elastic: true,filter: "num.####",order: -1,image: false},
                        {id:"lon",visible: true,f_type_id:"",f_type:"*",mousefeedback:true,title: "Lon",alignment_th: 'left_align',alignment_td: 'center_align',width: 60,elastic: true,filter: "num.####",order: -1,image: false},
                        {id:"speed",visible: true,f_type_id:"",f_type:"*",title: "Km/h",width:50,alignment_th: 'center_align',alignment_td: 'right_align',elastic: false,filter: "num.#",image: false},
                        {id:"gps",visible: true,f_type_id:"",f_type:"*",title: "V",width: 20,alignment_th: 'center_align',alignment_td: 'center_align',elastic: false,filter: "",image: false},
                        {id:"head",visible: true,f_type_id:"",f_type:"*",title: "Head",width: 50,alignment_th: 'center_align',alignment_td: 'right_align',elastic: false,filter: "num.#",image: false},
                        {id:"nmea",visible: true,f_type_id:"",f_type:"*",title: "NMEA",width: 50,alignment_th: 'center_align',alignment_td: 'center_align',elastic: false,filter: "",image: false}
                     ]

        vm.columns=columns
      },
      colClick(id,col,row){
        const vm=this
        vm.sel_id=row.id
        vm.selectedItem=row
        vm.centerMarker(row)
      },
     getWindowHeight(event) {
                const vm=this
                vm.windowHeight = document.documentElement.clientHeight;
                document.getElementById("gmap").setAttribute("style", "height:" + (vm.windowHeight -150) + 'px')
                vm.calcSizeBoxes()
            },

      calcSizeBoxes(){
          const vm=this
           var ele=document.getElementById("gmap")
           var gmap_height=ele.clientHeight;
           ele=document.getElementById("box1");
           var box1_height=ele.clientHeight;
           ele=document.getElementById("box2");
           var box2_height=ele.clientHeight;
           document.getElementById("box3").setAttribute("style", "height:" + (gmap_height - (box1_height+box2_height +50)) + 'px')
           document.getElementById(vm.options.id+"bw").setAttribute("style", "height:" + (gmap_height - (box1_height+box2_height +170)) + 'px') 
      },
 
        doShowAll(){
            const vm=this
            vm.centerAllMarkers()
        },
        async doExport(){
          const vm = this
          var response
          var fd = new FormData();
          fd.append('data', JSON.stringify(vm.rows));
          fd.append('ds', vm.getDecimalSeparator());
          response = await vm.axios.post(vm.api_server+'savecoordsnmea_c.php',fd)
    const url = window.URL.createObjectURL(new Blob([response.data], {type : "text/plain;charset=utf-8"}))
   const link = document.createElement('a')
   link.href = url;
   link.setAttribute('download', 'file.csv');
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
   window.URL.revokeObjectURL(url);
        },
        doTranslate(){
        const vm=this
        vm.sel_id=-1
        vm.selectedItem=null
        vm.calcSizeBoxes()
         vm.do_get_translate()
       },
        async do_get_translate() {
          const vm = this
          var response
          var myPostData={}
          var fd = new FormData();
          fd.append('data', vm.nmeaCode);
          myPostData.data=vm.nmeaCode
          response = await vm.axios.post(vm.api_server+'translatenmea_c.php',fd)
          vm.rows =response.data.pos;
          var c=1;
          for (var i=0; i<vm.rows.length; i++) {  
                vm.rows[i].id=c;
                c++;
          }
          vm.centerAllMarkers()
         }
   }
}
</script>

